import { currencyFormatter } from "src/utils/validators"

export function plan (state) {
    return state.plan
}

export function totalValue (state) {
    const discountPercent = 1 - state.plan.percentDiscount
    const value = state.plan.amountValue;
    return state.plan.percentDiscount > 0
        ? currencyFormatter.format(value * discountPercent)
        : currencyFormatter.format(value)
}

export function totalValueAnual (state) {
    const discountPercent = 1 - state.plan.percentDiscount
    const value = state.plan.amountValue;
    const monthlyValue = state.plan.percentDiscount > 0 ? value * discountPercent : value
    const anualyValue = monthlyValue * 12
    return currencyFormatter.format(anualyValue)
}